<template>
    <div>
        <form novalidate class="md-layout">
            <md-content class=" md-layout-item md-size-100 md-small-size-100">
                <div class="md-flex-center-center md-form-input md-relative">
                    <h1 class="md-title md-form-title">{{ $t('views.main.links.add-order') }}</h1>
                    <md-card class="md-form-card md-mt-70 cardBox">
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100 min-height">
                                <md-field :class="getValidationClass('name')" id="camp">
                                    <label for="name">{{ $t('views.order.campaign.form.label.name') }}</label>
                                    <md-input name="name" id="name" v-model="$v.form.name.$model" autocomplete="off"
                                              :disabled="sending" required />
                                    <span class="md-error"
                                          v-if="!$v.form.name.required">{{ $t('validation.required') }}</span>
                                    <span class="md-error" v-else-if="!$v.form.name.blockedChars">{{ $t('validation.blockedChars') }}</span>
                                    <server-error :server-errors="serverErrors" field-name="name" />
                                </md-field>
                            </div>

                            <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('agencyId')">
                                    <label for="agency">{{ $t('views.order.campaign.form.label.agency') }}</label>
                                    <SelectWithFilter :list="agencies" @input="pickAgency" v-model="$v.form.agencyId.$model"
                                        :name="`agency`" :id="`agency`" :disabled="ordersCount > 0" v-slot="{item}">
                                        <md-option :value="item.valueId">{{ item.name }}</md-option>
                                    </SelectWithFilter>
                                    <span class="md-error" v-if="!$v.form.agencyId.required">{{ $t('validation.required') }}</span>
                                    <server-error v-else field-name="agencyId" :server-errors="serverErrors" />
                                </md-field>
                                 <md-tooltip md-direction="top" class="alert" v-if="ordersCount > 0">{{ $t('views.order.campaign.form.orderIsAvailable') }}</md-tooltip>
                            </div>
                        </div>

                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('clientId')">
                                    <label for="client">{{ $t('views.order.campaign.form.label.client') }}</label>
                                    <SelectWithFilter :list="clientsList" v-model="$v.form.clientId.$model"
                                        :name="`client`" :id="`client`" :disabled="ordersCount > 0" v-slot="{item}">
                                        <md-option :value="item.id">{{ item.name }}</md-option>
                                    </SelectWithFilter>
                                    <span class="md-error" v-if="!$v.form.clientId.required">{{ $t('validation.required') }}</span>
                                    <server-error v-else field-name="clientId" :server-errors="serverErrors" />
                                </md-field>
                                <md-tooltip md-direction="top" class="alert" v-if="ordersCount > 0">{{ $t('views.order.campaign.form.orderIsAvailable') }}</md-tooltip>
                                <span class="alert noClients" v-if="clientsList.length === 0">{{ $t('views.order.campaign.form.noClients') }}</span>
                            </div>

                            <div class="md-layout-item md-small-size-100">
                                <div class="md-layout md-gutter">
                                    <div class="md-layout-item md-small-size-100 md-size-50">
                                        <md-datepicker class="md-required" v-model="$v.form.validFrom.$model"
                                                       :disabled="sending" :md-immediately="true"
                                                       :class="getValidationClass('validFrom')" :md-disabled-dates="disabledDatesValidFrom">
                                            <label>{{ $t('views.order.campaign.form.label.validFrom') }}</label>
                                            <div :class="this.form.validFrom ? !$v.form.validFrom.isSameOrBefore ? 'wrongPickedDate' : 'emptyDate' : 0">
                                            <span class="md-error" v-if="!$v.form.validFrom.required">{{ $t('validation.required') }}</span>
                                            <span class="md-error wrongDate" v-else-if="!$v.form.validFrom.isSameOrBefore">{{ $t('validation.isSameOrBefore', {0: $t('views.order.campaign.form.label.validTo')}) }}</span>
                                            <server-error v-else :server-errors="serverErrors"
                                                          field-name="validFrom" />
                                            </div>
                                        </md-datepicker>
                                    </div>

                                    <div class="md-layout-item md-small-size-100 md-size-50">
                                            <md-datepicker class="md-required" v-model="$v.form.validTo.$model"
                                                       :disabled="sending" :md-immediately="true"
                                                       :class="getValidationClass('validTo')" :md-disabled-dates="disabledDatesValidTo">
                                            <label>{{ $t('views.order.campaign.form.label.validTo') }}</label>
                                            <div :class="this.form.validTo ? !$v.form.validTo.isSameOrAfter ? 'wrongPickedDate' : 'emptyDate' : 0">
                                            <span class="md-error" v-if="!$v.form.validTo.required">{{ $t('validation.required') }}</span>
                                            <span class="md-error wrongDate" v-else-if="!$v.form.validTo.isSameOrAfter">{{ $t('validation.isSameOrAfter', {0: $t('views.order.campaign.form.label.validFrom')}) }}</span>
                                            <server-error v-else :server-errors="serverErrors"
                                                          field-name="validTo" />
                                            </div>
                                        </md-datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('description')">
                                    <label for="description">
                                        {{ $t('views.order.campaign.form.label.description') }}
                                    </label>
                                    <md-textarea name="description" id="description"
                                                 v-model="$v.form.description.$model"
                                                 :disabled="sending"
                                                 style="resize: none" />
                                    <span class="md-error" v-if="!$v.form.description.blockedChars">{{ $t('validation.blockedChars') }}</span>
                                    <server-error :server-errors="serverErrors" field-name="description" />
                                </md-field>
                            </div>
                        </div>
                    </md-card>
                </div>
            </md-content>
        </form>
    </div>
</template>

<script>
import {blockedChars, isAfter, isBefore, isDate, isSameOrAfter, isSameOrBefore} from '@/validators/validators';
import {required} from 'vuelidate/lib/validators';
import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
import ServerError from '@/components/ServerError';
import {agenciesEndpoint, campaignsEndpoint, clientsEndpoint} from '@/services/adsign-backend/endpoints';
import {mapActions, mapGetters} from 'vuex';
import store from "@/store";
import SelectWithFilter from '@/components/SelectWithFilter'


export default {
    name: 'CampaignForm',
    components: {ServerError, SelectWithFilter},
    mixins: [serverSideValidationErrors],
    props: {
        value: {
            type: Object,
            default: () => {
            }
        },
        ordersCount: {
            type: Number,
            default: 0
        }
    },
    computed: {
      clientsList() {
        if (this.form.agencyId) {
          return this.clients
          .filter(client => client.agency.id == this.form.agencyId)
          .map(client => client.client)
        }
        return this.clients
        .map(client => client.client);
      },
      ...mapGetters('order', ['campaign']),
    },
    data: function () {
        return {
            validFromCopy: null,
            validToCopy: null,
            sending: false,
            agencies: [],
            clients: [],
            form: {
                id: this.value?.id,
                name: this.value?.name,
                agencyId: this.value?.agencyId,
                clientId: this.value?.clientId,
                validFrom: this.value.validFrom ? this.value.validFrom : this.$moment().add(1, 'month').startOf('month').format('DD.MM.YYYY'),  // set 1st day of next month
                validTo: this.value.validTo ? this.value.validTo : this.$moment().add(1, 'month').endOf('month').format('DD.MM.YYYY'),
                description: this.value?.description
            },
            disabledDatesValidFrom: date => {
                const validDate = this.$moment()
                if(this.ordersCount > 0){
                  return  this.$moment(this.validFromCopy, 'DD.MM.YYYY').startOf('month') > this.$moment(date).toDate() || this.$moment(this.validToCopy, 'DD.MM.YYYY').endOf('month') < this.$moment(date).toDate()
                }
                return validDate > this.$moment(date).toDate()
            },
            disabledDatesValidTo: date => {
                const parseDate = this.$moment(this.form.validFrom, 'DD.MM.YYYY').toDate()
                if(this.ordersCount > 0){
                  return  this.$moment(this.validFromCopy, 'DD.MM.YYYY').startOf('month') > this.$moment(date).toDate() || this.$moment(this.validToCopy, 'DD.MM.YYYY').endOf('month') < this.$moment(date).toDate()
                }
                return this.$moment(date).toDate() < parseDate
            }
        };
    },
    methods: {
        createOrUpdateCampaign() {
            const campaignData = {
                name: this.form.name,
                validFrom: this.$moment(this.form.validFrom, 'L').format('YYYY-MM-DDT00:00:00'),
                validTo: this.$moment(this.form.validTo, 'L').format('YYYY-MM-DDT00:00:00'),
                clientId: this.form.clientId,
                agencyId: this.form.agencyId,
                description: this.form.description
            }
            if(this.validFromCopy === null && this.validToCopy === null){
                this.validFromCopy = this.form.validFrom
                this.validToCopy = this.form.validTo
            }
            if (this.form.id) {
                if (this.$v.form.$anyDirty) {
                    this.$v.form.$reset();
                    this.addValidDatesToStore();
                    return campaignsEndpoint.updateCampaign(this.form.id, campaignData, true)
                        .then(result => {
                            this.form.id = result.data.id;
                            this.$emit('input', this.form);
                        });
                }
                return Promise.resolve();
            } else {
                this.addValidDatesToStore();
                return campaignsEndpoint.createCampaign(campaignData)
                    .then(result => {
                        this.form.id = result.data.id;
                        this.$emit('input', this.form);
                    })
            };
        },
        addValidDatesToStore() {
            if (this.form.validFrom) {
                store.commit('order/VALID_FROM', this.form.validFrom);
            }

            if (this.form.validTo) {
                store.commit('order/VALID_TO', this.form.validTo);
            }
        },
        storeCampaignData() {
            this.campaign.common = this.form;
            this.campaign.common.validFrom = this.$moment(this.form.validFrom).isValid() ? this.$moment(this.form.validFrom).format('L') : this.form.validFrom;
            this.campaign.common.validTo = this.$moment(this.form.validTo).isValid() ? this.$moment(this.form.validTo).format('L') : this.form.validTo;
        },
        sync() {
            if (!this.$v.form.$invalid) {
                return this.createOrUpdateCampaign();
            }
            return Promise.reject("Campaign form is invalid");
        },
        ...mapActions('order', ['setCampaign']),
        pickAgency(id) {
            store.commit('misc/AGENCY_ID', id)
            this.form.agencyId = id
            if (this.clientsList.length > 0)
                return this.form.clientId = this.clientsList[0].id
            else
                return this.form.clientId = ''
        },
    },
    mounted() {
        this.$material.locale.firstDayOfAWeek = 1;
        this.$watch(() => this.$v.form.$anyDirty, newValue => {
            this.$emit('dirtyChange', newValue);
        });
        this.$watch(() => this.$v.form.$invalid, newValue => {
            this.$emit('validChange', !newValue);
        });
        this.$emit('validChange', !this.$v.form.$invalid);

        agenciesEndpoint.getAgencies('PRIVILEGE_ORDER_CREATE').then(result => {
            this.agencies = result.data.sort((a, b) => a.name < b.name ? -1 : 1)
            if (!this.form.id) {
                if(result.data.length > 0){
                    store.commit('misc/AGENCY_ID', result.data[0].id)
                    this.$v.form.agencyId.$model = result.data[0].id;
                }
            }
        });
        clientsEndpoint.getClients('PRIVILEGE_ORDER_CREATE').then(result => {
            this.clients = result.data
            if (!this.form.id) {
                if (this.form.agencyId) {
                    this.pickAgency(this.form.agencyId);
                    this.clients = result.data
                    this.form.clientId = this.form.clientId || result.data[0].id
                }
            }
        });

        this.addValidDatesToStore();
    },
    validations: {
        form: {
            name: {
                required,
                blockedChars: blockedChars('\t\';')
            },
            agencyId: { },
            clientId: {
                required
            },
            validFrom: {
                required,
                isSameOrBefore: isSameOrBefore('validTo')
            },
            validTo: {
                required,
                isSameOrAfter: isSameOrAfter('validFrom')
            },
            description: {
                blockedChars: blockedChars('\t\';')
            }
        }
    }
}
</script>


<style scoped lang="scss">
    ::v-deep {
        .md-datepicker input {
            min-width: 120px;
            height: 45px;
        }

        #name {
            height: 45px;
        }
    }

    .cardBox{
        margin-bottom: 10px;
        .wrongDate {
        top: 60px;
        }

        .wrongPickedDate {
        height:80px
        }

        .emptyDate {
        height: 30px
        }
    }

    .alert{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: -25px;
        font-size: 12px;
    }

    .noClients{
        margin-top: -5px;
        margin-bottom: 0;
        justify-content: flex-start;
        color: red
    }

    .filter{
      padding: 8px;
      border: none;
      border-bottom: 1px solid black;
      margin: 0px 10px 0px 10px;
      font-size: 15px;
    }

</style>
